<template>
    <div>

        <b-row>
        <b-col lg="12">
            <b-card no-body v-if="mostrarSemAct">
                <b-card-body class="px-1 pb-0 pt-1">
                    <b-row>
                    <b-col xl="1" lg="1" md="1" class="mb-1" align="center">
                        <b-button-group>
                        <b-button
                            variant="gradient-primary"
                            size="sm"
                            @click="mostrarSemAct = false"
                            id="btn_back"
                            v-b-tooltip.hover="'Regresar'"
                        >
                            <font-awesome-icon icon="fa-solid fa-arrow-left-long"/>
                        </b-button>
                        <b-button
                            variant="gradient-primary"
                            size="sm"
                            @click="descargarMasiva()"
                            id="imp_semAct"
                            :disabled="estado_btn_descargamasiva"
                            v-b-tooltip.hover="'Descargar Registros'"

                        >
                            <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                            <font-awesome-icon v-else icon="fa-solid fa-download"/>
                        </b-button>
                        </b-button-group>
                    </b-col>
                    <b-col xl="11" lg="11" md="1" class="mb-1" align="center">
                        <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Detalle de registro - Total: ${this.items_detalle.length}` }}</span>
                    </b-col>
                    </b-row>
                </b-card-body>

                <b-table
                    ref="tableDetalleSemanaActual"
                    responsive
                    hover
                    outlined
                    small
                    sticky-header="58vh"
                    class="position-relative tablaferti"
                    :items="items_detalle"
                    :fields="fields_detalle_SemAct"
                    :busy="loading"
                    show-empty
                    empty-text="No se encontraron datos en esta tabla."

                >
                    <template #table-busy>
                    <div class="text-center text-dark my-1">
                        <b-spinner class="align-middle"></b-spinner> &emsp;
                        <strong>Obteniendo datos...</strong>
                    </div>
                    </template>


                    <!-- Agregar checkbox en el header -->
                    <template #head(check)="data">
                        <b-form-checkbox v-model="selectAll" @change="toggleSelectAll"/>
                    </template>

                    <!-- Agregar una columna para el checkbox en las filas -->
                    <template #cell(check)="data">
                        <b-form-checkbox
                            :value="data.item.nombre_archivo"
                            v-model="selected"
                            class="custom-control-success"
                            @change="validarCheckSeleccionados"
                        />
                    </template>

                    <template #cell(pdf)="data">
                        <div class="text-nowrap" >
                            <b-img
                                v-b-tooltip.hover
                                title="Descargar PDF"
                                :src="require('@/assets/images/icons/pdf1.png')"
                                height="auto"
                                width="20"
                                @click="generarPdf(data.item)"
                            />
                        </div>
                    </template>

                    <template #cell(estado)="data">
                    <b-badge :variant="status[1][parseInt(data.value)]">
                        {{ status[0][parseInt(data.value)] }}
                    </b-badge>
                    </template>

                    <template #cell(created)="data">
                        <span>
                            {{
                            new Date(data.value).toLocaleString('pe-PE', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                localeMatcher: 'best fit',
                                hour: '2-digit',
                                minute: '2-digit',
                                timeZone: 'America/Lima'
                            })
                            }}
                        </span>
                    </template>
                </b-table>
            </b-card>

            <b-card no-body v-else>
                <b-card-body class="px-1 pb-0 pt-1">
                    <b-row>
                        <b-col xl="3" lg="3" md="3" class="mb-1 align-self-center">
                            <b-button-group>
                            <b-button
                                variant="gradient-primary"
                                size="sm"
                                @click="obtenerListaArchivos"
                                id="act_semAct"
                                :disabled="loading"
                                v-b-tooltip.hover="'Actualizar Tabla'"
                            >
                                <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
                            </b-button>
                            <b-button
                                variant="gradient-primary"
                                size="sm"
                                @click="modal_registro(true)"
                                id="cre_semAct"
                                :disabled="loadingSAC"
                                v-b-tooltip.hover="'Crear Registro'"
                            >
                                <font-awesome-icon v-if="loadingSAC" icon="fa-solid fa-arrows-rotate" spin/>
                                <font-awesome-icon v-else icon="fa-solid fa-plus"/>
                            </b-button>
                            <!-- <b-button
                                variant="gradient-primary"
                                size="sm"
                                v-if="$can('create', 'Pr Fert Programacion')"
                                @click="mostrarModalImportar(true)"
                                id="imp_semAct"
                                :disabled="loadingSAM"
                                v-b-tooltip.hover="'Importar Registros'"
                            >
                                <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                                <font-awesome-icon v-else icon="fa-solid fa-file-excel"/>
                            </b-button>
                            <b-button
                                variant="gradient-primary"
                                size="sm"
                                v-if="$can('create', 'Pr Fert Programacion')"
                                @click="descargarRegistros(true)"
                                id="imp_semAct"
                                :disabled="loadingSAD"
                                v-b-tooltip.hover="'Descargar Registros'"
                            >
                                <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                                <font-awesome-icon v-else icon="fa-solid fa-download"/>
                            </b-button> -->
                            </b-button-group>
                        </b-col>
                        <b-col xl="9" lg="9" md="9" class="mb-1" align="center">
                            <!-- <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;">{{`Semana actual N° ${this.semana}`}}</span><br>
                            <span class="font-weight-bolder font-small-4" style="vertical-align: -webkit-baseline-middle!important;">{{`Del ${this.inicioSemana} al ${this.finSemana}` }}</span> -->
                        </b-col>
                    </b-row>
                </b-card-body>

                <b-table
                    ref="tableSemanaActual"
                    responsive
                    hover
                    outlined
                    small
                    sticky-header="58vh"
                    class="position-relative tablaferti"
                    :items="items"
                    :fields="fields"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="cPaginacion"
                    :busy="loading"
                    show-empty
                    empty-text="No se encontraron datos en esta tabla."
                    emptyFilteredText="No se encontraron datos con los parámetros ingresados."
                >
                    <template #table-busy>
                        <div class="text-center text-dark my-1">
                            <b-spinner class="align-middle"></b-spinner> &emsp;
                            <strong>Obteniendo datos...</strong>
                        </div>
                    </template>

                    <template #cell(acciones)="data">
                        <div class="text-nowrap">
                            <feather-icon
                                :id="`btn_${data.item.id}_detalle`"
                                icon="EyeIcon"
                                size="16"
                                class="mr-1 text-primary"
                                @click="verDetalle(data.item)"
                                v-b-tooltip.hover="'Ver detalle'"
                            />

                            <!-- <feather-icon
                                :id="`btn_${data.item.id}_editar`"
                                icon="EditIcon"
                                size="16"
                                class="mr-1"
                                @click="validarEditar(data.item)"
                            /> -->

                            <!-- <feather-icon
                                v-if="$can('authorize', 'Pr Fert Programacion')"
                                :id="`btn_${data.item.id}_autorizar`"
                                icon="UserCheckIcon"
                                size="16"
                                @click="autorizar(data.item)"
                                v-b-tooltip.hover="'Cambiar Estado'"
                            /> -->
                        </div>
                    </template>


                    <template #cell(estado)="data">
                        <b-badge :variant="status[1][parseInt(data.value)]">
                            {{ status[0][parseInt(data.value)] }}
                        </b-badge>
                    </template>

                    <template #cell(created)="data">
                        <span>
                            {{
                                new Date(data.value).toLocaleString('pe-PE', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                localeMatcher: 'best fit',
                                hour: '2-digit',
                                minute: '2-digit',
                                timeZone: 'America/Lima'
                                })
                            }}
                        </span>
                    </template>
                </b-table>
            </b-card>
        </b-col>

      </b-row>

      <b-modal
          id="modal-prevent-closing"
          v-model="modal_registro_o"
          ref="my-modal"
          title="Nuevo Registro"
          ok-title="Registrar"
          cancel-title="Cancelar"
          cancel-variant="outline-secondary"
          size="md"
          :cancel-disabled="loading2"
          :ok-disabled="loading2"
          centered
          no-close-on-esc
          no-close-on-backdrop
          @show="resetModal"
          @hidden="resetModal"
          @ok="handleOk"
      >
        <div v-if="loading2"  align="center">
          <p>Registrando ... </p>
          <b-spinner label="Loading..." variant="primary"/>
        </div>
        <validation-observer v-else ref="formularioRiego" #default="{invalid}">
          <b-form autocomplete="off" @submit.prevent="registrarNuevo">
            <b-row>
              <b-col lg="12">
                <b-form-group
                    label="Sociedad"
                    label-for="sociedad"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="sociedad"
                      vid="sociedad"
                      rules="required"
                  >
                    <v-select
                        id="sociedad"
                        v-model="sociedad"
                        :options="sociedades"
                        placeholder="Seleccionar sociedad..."
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="12">
                <b-form-group
                    label="Tipo"
                    label-for="tipo"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="tipo"
                      vid="tipo"
                      rules="required"
                  >
                    <v-select
                        id="tipo"
                        v-model="tipo"
                        :options="tipos"
                        placeholder="Seleccionar tipo..."
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="12">
                <b-form-group
                label="Descripcion"
                label-for="descripcion"
                >
                    <b-form-textarea
                        v-model="descripcion"
                        id="textarea-small"
                        size="sm"
                        placeholder="Escriba aqui la descripcion..."
                    />

                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
                <b-col lg="12">
                    <b-form-group
                        label="Carga de Archivos"
                        label-for="cargaarchivos"
                    >
                        <validation-provider
                            #default="{ errors }"
                            name="cargaarchivos"
                            vid="cargaarchivos"
                            rules="required"
                        >
                        <b-form-file
                            id="archivo"
                            accept=".htm,.html"
                            placeholder="Seleccionar solo Archivos HTM (.htm)"
                            v-model="archivos_htm"
                            @input="validarSoloHTM()"
                            ref="fileinput"
                            multiple
                        >
                            <template
                                slot="file-name"
                                slot-scope="{ names }"
                            >
                            <b-badge variant="primary">
                                {{ names[0] }}
                            </b-badge>
                            </template>
                        </b-form-file>
                        <small class="text-danger" style="font-weight: bold;">{{ errors[0] }}</small>
                        </validation-provider>
                        <br>
                        <span style="font-size:12px; color:#EA5455; font-weight: bold;"> {{ msj_error_cargaarchivos }} </span>
                        <br>
                        <span style="margin-top:12px; font-size:12px; font-weight: bold;">Archivos adjuntos: {{ archivos_htm.length }}</span>
                      </b-form-group>
                </b-col>
            </b-row>

          </b-form>
        </validation-observer>
      </b-modal>

      <b-modal
          id="modal-editar"
          ref="modal-editar"
          v-model="estadoModalEditar"
          title="Editar Registro"
          ok-title="Editar"
          cancel-title="Cancelar"
          cancel-variant="outline-secondary"
          :size="loadingEDI ? 'md':'xl'"
          :cancel-disabled="loadingEDI"
          :ok-disabled="loadingEDI"
          centered
          no-close-on-esc
          no-close-on-backdrop
          @show=""
          @hidden="resetModal"
          @ok="validarRegistroEditar"
      >
        <div v-if="loading2"  align="center">
          <p>Editando ... </p>
          <b-spinner label="Loading..." variant="primary"/>
        </div>
        <validation-observer v-else ref="formularioEditarRiego" #default="{invalid}">
          <b-form autocomplete="off" @submit.prevent="editarRegistro">
            <b-row>
              <b-col lg="2">
                <b-form-group
                    label="Semana"
                    label-for="semana_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Semana"
                      vid="semana_e"
                      rules="required|integer|between:1,52"
                  >
                    <b-form-input
                        id="semana_e"
                        v-model="semana"
                        :state="errors.length > 0 ? false:null"
                        name="semana"
                        @input="asignarInicioFinSemana"
                        disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="3">
                <b-form-group
                    label="Fundo"
                    label-for="fundo_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Fundo"
                      vid="fundo_e"
                      rules="required"
                  >
                    <v-select
                        id="fundo_e"
                        v-model="fundo"
                        :options="fundos"
                        placeholder="Seleccionar fundo..."
                        @input="asignarEtapas"
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="3">
                <b-form-group
                    label="Campo"
                    label-for="campo_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Campo"
                      vid="campo_e"
                      rules="required"
                  >
                    <v-select
                        id="campo_e"
                        v-model="campo"
                        :options="campos"
                        placeholder="Seleccionar campo..."
                        @input="asignarTurnos"
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col lg="3">
                <b-form-group
                    label="Turno"
                    label-for="turno_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Turno"
                      vid="turno_e"
                      rules="required"
                  >
                    <v-select
                        id="turno_e"
                        v-model="turno"
                        :options="turnos"
                        placeholder="Seleccionar turno..."
                        @input="asignarCodigos"
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col lg="3">
                <b-form-group
                    label="Codigo Homologado"
                    label-for="codigo_h_e"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Codigo Homologado"
                      vid="codigo_h_e"
                      rules="required"
                  >
                    <v-select
                        id="codigo_h_e"
                        v-model="codigo_h"
                        :options="codigos_h"
                        :reduce="codigos_h => codigos_h.data"
                        label="codigo_h"
                        key="data"
                        placeholder="Seleccionar codigo..."
                        @input="seleccionarCodigoN"
                    >
                      <span slot="no-options">No se encontraron datos.</span>
                    </v-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>

      <b-modal
          id="modal-importar"
          ref="modal-importar"
          v-model="estadoModalImportar"
          title="Importar Datos Masivos"
          ok-title="Importar"
          cancel-title="Cancelar"
          cancel-variant="outline-secondary"
          size="md"
          :cancel-disabled="loadingIMP"
          :ok-disabled="loadingIMP||!archivo_excel"
          centered
          no-close-on-esc
          no-close-on-backdrop
          @show=""
          @hidden=""
          @ok="importarOk"
      >
        <div v-if="loadingIMP"  align="center">
          <p>Importando datos ... </p>
          <b-spinner label="Loading..." variant="primary"/>
        </div>
        <validation-observer v-else ref="formularioImportar" #default="{invalid}">
          <b-form autocomplete="off" @submit.prevent="enviarFile">
            <b-row>
              <b-col lg="12">
                <b-form-group
                    label="Archivo"
                    label-for="archivo"
                >
                  <validation-provider
                      #default="{ errors }"
                      name="Archivo"
                      vid="archivo"
                      rules="required"
                  >
                    <b-form-file
                        id="archivo"
                        accept=".xlsx"
                        placeholder="Seleccionar Archivo Excel (.xlsx)"
                        v-model="archivo_excel"
                        ref="fileinput"
                    >
                      <template
                          slot="file-name"
                          slot-scope="{ names }"
                      >
                        <b-badge variant="primary">
                          {{ names[0] }}
                        </b-badge>
                      </template>
                    </b-form-file>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-modal>


      <b-modal
          id="modal-respuesta"
          ref="modal-respuesta"
          v-model="mostrarErrores"
          title="Errores en el registro"
          ok-title="Aceptar"
          ok-only
          size="md"
          no-close-on-esc
          no-close-on-backdrop
          @show=""
          @hidden=""
          scrollable
      >
        <b-row>
          <b-col lg="12">
            <span>Las siguientes filas no se pudieron registrar:</span>
            <div
                v-for="error in respuestaErrores"
                :key="error.contador2"
            >
              <div class="mb-1">
                <br>
                <span>Fila: {{ error.id }}</span><br>
                <span>Codigo homologado: {{ error.cod_homologado }}</span><br>
                <span>Error: {{ error.error }}.</span>
              </div>
            </div>


          </b-col>
        </b-row>
      </b-modal>

      <b-modal
          id="modal-respuesta"
          ref="modal-respuesta"
          v-model="estadoModalRespuesta"
          ok-title="Aceptar"
          ok-only
          size="md"
          no-close-on-esc
          no-close-on-backdrop
          @show=""
          @hidden=""
          scrollable
          hide-footer
          center
      >
        <b-row>
          <b-col lg="12">
            <font-awesome-icon icon="fa-solid fa-cloud-arrow-down" style="position:relative; left: 50%; top:40px; bottom: 20px; margin-left:-25px; font-size:80px; color:#afba37"/>
            <h5 style="margin-top: 45px;">Los archivos se estan descargando...Por favor espere</h5>
            <!-- <span>Se realizó la creación de registros satisfactoriamente.</span>
            <div
                v-for="error in respuestaErrores"
                :key="error.contador2"
            >
              <div class="mb-1">
                <span>Codigo homologado: {{ error.cod_homologado }}</span><br>
                <span>Error: {{ error.error }}.</span>
              </div>
            </div> -->
          </b-col>
        </b-row>
      </b-modal>

    </div>
  </template>

  <script>

  import axiosIns from '../../libs/axios'
  import vSelect from 'vue-select'
  import {
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BImg,
    BFormSelect,
    BModal,
    BPagination,
    BSpinner,
    BTable,
    BRow,
    BCol,
    BDropdownDivider,
    BFormFile,
    BFormCheckbox,
    VBModal,
    BTooltip,
    BInputGroup,
    BFormDatepicker,
    BFormTimepicker,
    BInputGroupAppend,
    BInputGroupPrepend, BFormTextarea, BLink, BButtonGroup,
    BAlert, VBTooltip,
  } from 'bootstrap-vue'
  import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
  import { required, double, max, between, integer } from '@validations'
  import ToastificationContent from '@core/components/toastification/ToastificationContent'

  export default {
    components: {
      BCard,
      BCardBody,
      BTable,
      BSpinner,
      BImg,
      BBadge,
      BFormGroup,
      BFormSelect,
      BPagination,
      BButton,
      BFormInput,
      BModal,
      BFormCheckbox,
      VBModal,
      BForm,
      BCol,
      BRow,
      BDropdownDivider,
      BFormFile,
      BTooltip,
      BInputGroup,
      BInputGroupAppend,
      BInputGroupPrepend,
      BFormTextarea,
      BLink,
      BFormDatepicker,
      BFormTimepicker,
      BButtonGroup,
      BAlert,

      vSelect,

      ValidationProvider,
      ValidationObserver,
    },
    directives: {
      'b-modal': VBModal,
      'b-tooltip': VBTooltip,
    },
    data: () => ({
      id_user: JSON.parse(localStorage.getItem('userData')).id,
      inicioSemana: null,
      finSemana:null,
      codigo_h:null,
      msj_error_cargaarchivos:'',

      semana: null,
      fundo: null,
      cultivo: null,
      cultivoIMP: null,
      etapa: null,
      empresa: null,
      campo: null,
      turno: null,
      cod_homologado:null,
    //   archivos_htm:null,
      archivos_htm: [],
      selected:[],
      variedad: null,
      lote: null,
      valvula: null,
      area: null,

      eto:null,
      kc:null,
      lr_dia:null,
      descarga_caudal_hora:null,

      volumen:null,
      ciclos_riego:null,
      riego_total:null,
      horas:null,
      riego_cortina:null,
      con_sin_fertilizante:null,


      ciclo_1:null,
      estanque_uno_1:null,
      estanque_dos_1:null,
      estanque_tres_1:null,
      hora_inicio_1:null,
      horas_inicio_seg_ciclo:null,
      tipo:'',
      ciclo_2:null,
      estanque_uno_2:null,
      estanque_dos_2:null,
      estanque_tres_2:null,
      hora_inicio_2:null,
      horas_inicio_ter_ciclo:null,

      ciclo_3:null,
      estanque_uno_3:null,
      estanque_dos_3:null,
      estanque_tres_3:null,
      hora_inicio_3:null,
      comentarios:null,

      title_sem: null,
      detalle_sociedad:null,

      empresaFiltro: null,
      empresasFiltro: [],
      semanaFiltro: null,
      semanasFiltro: [],
      cultivoFiltro: null,
      cultivosFiltro: [],

      dias: null,
      descripcion:null,

      indicador: null,

      submittedNames: [],
      loading: false,
      loading2: false,
      loadingBP: false,
      loadingDE: false,
      loadingIMP: false,
      loadingEDI: false,

      loadingSAC: false,
      loadingSSC: false,
      loadingSSM: false,
      loadingSAM: false,
      loadingSAD: false,
      loadingSSD: false,

      // CalcularLrDia:false,
      estadoModalEditar: false,
      estadoModalImportar: false,
      estadoModalRespuesta: false,
      mostrarErrores:false,
      errores_res_impor:'',
      modal_registro_o: false,

      modalEditarEstadoShow: false,
      items: [],
      items_completo: [],
      items_detalle:[],
      selectAll: false,
      selected:[],
      estado_btn_descargamasiva:true,
      sociedad:null,
      sociedades:[
        'AGROVISION PERU S.A.C','ARENA VERDE'
      ],
      perPage: 5,
      pageOptions: [5, 10, 15, 30],
      totalRows: 0,
      currentPage: 1,
      sortBy: 'id',
      sortDesc: true,
      sortDirection: 'desc',
      filter: null,
      filter_sig: null,
      filterOn: ['semana'],
      fields: [
        {
          key: 'acciones',
          label: '# ',
          class: 'text-nowrap text-center',
          stickyColumn: true,
        },
        {
          key: 'created',
          label: 'fecha_creacion',
          class: 'text-nowrap text-center',
          sortable: true,
        },
        {
          key: 'sociedad',
          label: 'sociedad',
          class: 'text-nowrap text-center',
          sortable: true,
        },
        {
          key: 'descripcion',
          label: 'descripcion',
          class: 'text-nowrap text-center',
          sortable: true,
        },
        {
          key: 'tipo',
          label: 'tipo',
          class: 'text-nowrap text-center',
          sortable: true,
        },
        {
          key: 'nombre_usuario',
          label: 'creado por',
          class: 'text-nowrap text-center',
          sortable: true,
        },



      ],
      fields_detalle_SemAct: [
        {
            key: 'check',
            label: ' ',
            class: 'text-nowrap text-center',
        },
        // {
        //     key: 'pdf',
        //     label: '#',
        //     tdClass: 'alinear-una-sola-linea  text-center',
        // },
        {
          key: 'created',
          label: 'fecha_creacion',
          class: 'text-nowrap text-center',
          sortable: true,
        },
        {
          key: 'descripcion',
          label: 'descripcion',
          class: 'text-nowrap text-center',
          sortable: true,
        },
        {
          key: 'tipo',
          label: 'tipo',
          class: 'text-nowrap text-center',
          sortable: true,
        },
        {
          key: 'nombre_archivo',
          label: 'nombre_archivo',
          class: 'text-nowrap text-center',
          sortable: true,
        },
        {
          key: 'nombre_usuario',
          label: 'creado por',
          class: 'text-nowrap text-center',
          sortable: true,
        },
      ],

      espanol:{
        labelNoTimeSelected: 'Seleccione Hora',
      },

      status: [
        {
          0: 'Pendiente',
          1: 'Revisado',
          2: 'Aprobado',
          3: 'Desaprobado',
          4: 'Eliminado',
        },
        {
          0: 'light-info',
          1: 'light-warning',
          2: 'light-success',
          3: 'light-danger',
          4: 'light-dark',
        }
      ],

      con_sin_fertilizantes:[
        {value:'SI',text:'SI'},
        {value:'NO',text:'NO'}
      ],

      estados: [
        {value: '1', text: "Dar visto bueno"},
        /*
        {value: '1', text: "Observar"},
        {value: '3', text: "Desaprobar"}
         */
      ],

      parametros_usuario: [],

      estado_aprobar: null,

      archivo_excel: null,
      empresas: ['AGROVISION PERU SAC','ARENA VERDE'],
      tipos:['ALTA','BAJA'],
    //   cultivos: [],
    //   cultivosIMP: ['ARANDANO', 'ESPARRAGO', 'PALTA', 'UVA'],
    //   fundos: [],
    //   etapas: [],
    //   campos: [],
    //   turnos: [],
    //   codigos_h: [],
      parametros: [],

      dataEmpresa: [],
      dataLotesValvulas: [],
      notDuplicados: [],
      dataCompleta: [],

      spd: [],
      dia: null,
      hora: null,
      // -------

      comentario: null,

      semana_sig: null,
      inicioSemana_sig: null,
      finSemana_sig: null,

      mostrarSemAct: false,
      mostrarSemSgte: false,
      items_sem_act: [],
      items_sem_sgte: [],
      responsable: [],

      dataAutorizar:null,

      semanaActual: true,
      semanaEnviar: null,

      mostrarAlert: false,
      mostrarAlert2: false,

      respuestaRegistrosTotal: 0,
      respuestaErrores: [],



      // validation rules
      required,
      double,
      max,
      between,
      integer,
    }),
    computed: {

    },

    async mounted() {
      await this.obtenerListaArchivos();
      localize("es");
    },
    methods: {
    //   dataInicial(){
    //     const spd = this.numeroDeSemana(new Date())
    //     this.semana = spd.n_semana.toString().padStart(2, '0')
    //     this.inicioSemana = spd.inicio.toLocaleString('pe-PE', {
    //       month: 'long',
    //       day: '2-digit',
    //       year: 'numeric',
    //       localeMatcher: 'best fit',
    //       timeZone: 'America/Lima'
    //     })
    //     this.finSemana = spd.fin.toLocaleString('pe-PE', {
    //       month: 'long',
    //       day: '2-digit',
    //       year: 'numeric',
    //       localeMatcher: 'best fit',
    //       timeZone: 'America/Lima'
    //     })

    //     this.semana_sig = spd.n_semana === 52 ? '01' : (spd.n_semana + 1).toString().padStart(2, '0')
    //     // this.semana_sig = spd.n_semana + 1
    //     spd.inicio.setDate(spd.inicio.getDate() + 7)
    //     spd.fin.setDate(spd.fin.getDate() + 7)

    //     this.inicioSemana_sig = spd.inicio.toLocaleString('pe-PE', {
    //       month: 'long',
    //       day: '2-digit',
    //       year: 'numeric',
    //       localeMatcher: 'best fit',
    //       timeZone: 'America/Lima'
    //     })
    //     this.finSemana_sig = spd.fin.toLocaleString('pe-PE', {
    //       month: 'long',
    //       day: '2-digit',
    //       year: 'numeric',
    //       localeMatcher: 'best fit',
    //       timeZone: 'America/Lima'
    //     })

    //     this.filter = this.semana
    //     this.filter_sig = this.semana_sig

    //   },

        closeSwal(swalInstance) {
            // Cerrar SweetAlert utilizando la instancia almacenada
            if (swalInstance) {
                swalInstance.close();
            }
        },

        // autoClose() {
        //     // Almacenar la instancia de SweetAlert en una variable
        //     const swalInstance = this.$swal({
        //         title: 'Descargando...',
        //         icon: 'info',
        //         html: 'Por favor espere',
        //         showConfirmButton: false,
        //         allowEscapeKey: false,
        //         allowOutsideClick: false,
        //     });

        //     // Ejemplo de cómo cerrar SweetAlert desde otra función (simulación)
        //     setTimeout(() => {
        //         this.closeSwal(swalInstance);
        //     }, 3000);
        // },

        toggleSelectAll() {
            if (this.selectAll == true){
                for (let x of this.items_detalle){
                    this.selected.push(x['nombre_archivo'])
                    this.estado_btn_descargamasiva=false
                }
            }else{
                this.selected=[]
                this.estado_btn_descargamasiva=true
            }

        },

        onCheckboxChange() {
            this.selectAll = this.items_detalle.every(item => item.selected);
        },

        validarSoloHTM(){

          this.msj_error_cargaarchivos=''
          const regex = /\.htm?$/;
          var conta = 0

          for(let x of this.archivos_htm){

            if(regex.test(x['name'])){

            }else{
              conta = conta + 1
            }
          }

          if(conta>0){
            this.archivos_htm=[]
            this.msj_error_cargaarchivos="Solo deben subirse archivos .htm"

          }

        },

        descargarMasiva() {
            const yo=this
            // this.autoClose();

            // Almacenar la instancia de SweetAlert en una variable
            const swalInstance = this.$swal({
                title: 'Descargando...',
                icon: 'info',
                html: 'Por favor espere',
                showConfirmButton: false,
                allowEscapeKey: false,
                allowOutsideClick: false,
            });


            // yo.estadoModalRespuesta=true
            var lista_archivos=yo.selected

            const data=JSON.stringify(
                {
                  'lista_archivos': lista_archivos,
                  'detalle_sociedad': yo.detalle_sociedad
                }
            )

            const config={
                method:'post',
                url:'/utilidades/nominas/generarArchivosAltasBajasMasivo/pdf/',
                headers: {
                    'Content-Type': 'application/json'
                },
                responseType: 'arraybuffer',
                data : data
            }

            axiosIns(config)
                .then(function(response){
                if(response.status===200){
                    // Crea una URL para el archivo ZIP recibido
                    const zip_url = URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));

                    // Crea un enlace de descarga
                    const link = document.createElement('a');
                    link.href = zip_url;
                    link.setAttribute('download', 'archivos_pdf.zip'); // Nombre del archivo ZIP

                    // Agrega el enlace al cuerpo del documento y haz clic para descargar
                    document.body.appendChild(link);
                    link.click();

                    yo.closeSwal(swalInstance);
                    yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "La descarga se realizó correctamente", 'success', 5000)
                }
                })
                .catch(function (error) {
                    console.log(error);
                    yo.closeSwal(swalInstance)
                    yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Error en la descarga',
                      icon: 'XIcon',
                      text: 'Ocurrió un error al generar el consolidado.',
                      variant: 'danger',
                    },
                  })
                })
                .finally(function () {
                    // yo.estadoModalRespuesta=false
                });

        },

        validarCheckSeleccionados(){
            if( this.selected.length == 0 ){
                this.estado_btn_descargamasiva=true
            }else{
                this.estado_btn_descargamasiva=false
            }
        },

        generarPdf(datos){
            const yo=this

            // Almacenar la instancia de SweetAlert en una variable
            const swalInstance = this.$swal({
                title: 'Descargando...',
                icon: 'info',
                html: 'Por favor espere',
                showConfirmButton: false,
                allowEscapeKey: false,
                allowOutsideClick: false,
            });

            var nombre_archivo=datos['nombre_archivo']
            var tipo=datos['tipo']
            var fecha_creacion=datos['created']
            const data=JSON.stringify(
                {
                'nombre_archivo':nombre_archivo,
                'tipo':tipo,
                'created':fecha_creacion,
                // 'rango_fecha':yo.dateRange
                }
            )

            const config={
                method:'post',
                url:'/utilidades/nominas/generarArchivosAltasBajas/pdf/',
                headers: {
                    'Content-Type': 'application/json'
                },
                responseType: 'arraybuffer',
                data : data
            }

             (config)
                .then(function(response){
                if(response.status===200){
                    // Crea una URL para el archivo ZIP recibido
                    const zip_url = URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }));

                    // Crea un enlace de descarga
                    const link = document.createElement('a');
                    link.href = zip_url;
                    link.setAttribute('download', nombre_archivo + '.zip');

                    // Agrega el enlace al cuerpo del documento y haz clic para descargar
                    document.body.appendChild(link);
                    link.click();

                    yo.closeSwal(swalInstance);
                }
                })
                .catch(function (error) {
                  console.log(error);
                })
                .finally(function () {
                yo.loadingExcel = false
                });

        },

      obtenerListaArchivos(){
        const yo = this

        const config = {
          method: 'post',
          url: 'utilidades/nominas/obtenerListayAltasBajas/'
        }

        axiosIns(config)
            .then(function (response) {

              if(response.status === 200){
                yo.items=response.data['response']
                // Agrupar los elementos por id, created, tipo y descripcion
                const groupedItems = yo.items.reduce((accumulator, current) => {
                const { id, created, tipo, descripcion, nombre_usuario, sociedad } = current;
                const key = `${id}_${created}_${tipo}_${descripcion}`;

                if (!accumulator[key]) {
                    accumulator[key] = {
                    id,
                    created,
                    tipo,
                    descripcion,
                    nombre_usuario,
                    sociedad,
                    items: [current],
                    };
                } else {
                    accumulator[key].items.push(current);
                }

                return accumulator;
                }, {});

                // Convertir el objeto agrupado en una lista
                const result = Object.values(groupedItems);
                yo.items=result
                yo.items_completo=response.data['response']

              }
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(function (){
              yo.loadingDE = false
            })

      },

      asignarCultivos(){
        const yo = this
        yo.cultivos = []
        yo.cultivo = null
        yo.fundos = []
        yo.fundo = null
        yo.etapas = []
        yo.etapa = null
        yo.campos = []
        yo.campo = null
        yo.turnos = []
        yo.codigos_h = []
        yo.codigo_h = null
        yo.turno = null
        yo.variedad = null
        yo.lote = null
        yo.valvula = null
        yo.area = null

        for(let value of yo.dataEmpresa){
          if(value.sociedad === yo.empresa){
            yo.cultivos.push(value.cultivo)
          }
        }

        yo.cultivos = [... new Set(yo.cultivos)]

      },

      seleccionarCodigoN(){
        const yo = this
        yo.variedad = null
        yo.lote = null
        yo.valvula = null
        yo.area = null

        yo.variedad = yo.codigo_h.variedad
        yo.area = yo.codigo_h.area
        yo.lote = yo.codigo_h.lote
        yo.valvula = yo.codigo_h.valvula
      },

      cPaginacion(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },

      //NUEVO REGISTRO

      registrarNuevo() {

        const yo = this

        this.$refs.formularioRiego.validate().then(success => {
            if (success && !yo.mostrarAlert && !yo.mostrarAlert2)  {

                yo.loading2 = true

                const data = new FormData();

                // Agregar todos los archivos HTM a FormData
                for (let i = 0; i < yo.archivos_htm.length; i++) {
                data.append('file', yo.archivos_htm[i]);
                }

                data.append('sociedad', yo.sociedad);
                data.append('tipo', yo.tipo);
                data.append('descripcion', yo.descripcion);
                data.append('idresponsable', yo.id_user);
                data.append('tipo', yo.tipo);

                const config = {
                method: 'post',
                url: 'utilidades/nominas/registrarAltasBajas/',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                data: data
                }

                axiosIns(config)
                    .then(function (response) {

                    if (response.status === 200 ){
                        yo.obtenerListaArchivos();

                    }


                    })
                    .catch(function (error) {
                        console.log(error);
                        yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger', 5000)
                    })
                    .finally(function (){
                        yo.$nextTick(() => {
                        yo.$refs['my-modal'].toggle('#toggle-btn')
                    })
                    yo.loading2 = false
                    })

          }
        })
      },

      editarRegistro(){
        const yo = this

        this.$refs.formularioEditarRiego.validate().then(success => {
          if (success){
            yo.loadingEditar = true

            const data = JSON.stringify({
              'semana': yo.semanaActual ? yo.semana : yo.semana_sig,
              'fundo': yo.fundo,
              'cultivo': yo.cultivo,
              'etapa': yo.etapa,
              'empresa': yo.empresa,
              'campo': yo.campo,
              'turno': yo.turno,
              'cod_homologado':yo.codigo_h.codigo_h,

              'variedad': yo.variedad,
              'lote': yo.lote,
              'valvula': yo.valvula,
              'area': yo.area,

              'eto': yo.eto,
              'kc': yo.kc,
              'lr_dia':yo.lr_dia,
              'descarga_caudal_hora':yo.descarga_caudal_hora,

              'volumen':yo.volumen,
              'ciclos_riego':yo.ciclos_riego,
              'riego_total':yo.riego_total,
              'horas':yo.horas,
              'riego_cortina':yo.riego_cortina,
              'con_sin_fertilizante':yo.con_sin_fertilizante,

              'ciclo_1':yo.ciclo_1,
              'estanque_uno_1':yo.estanque_uno_1,
              'estanque_dos_1':yo.estanque_dos_1,
              'estanque_tres_1':yo.estanque_tres_1,
              'hora_inicio_1':yo.hora_inicio_1,
              'horas_inicio_seg_ciclo':yo.horas_inicio_seg_ciclo,

              'ciclo_2':yo.ciclo_2,
              'estanque_uno_2':yo.estanque_uno_2,
              'estanque_dos_2':yo.estanque_dos_2,
              'estanque_tres_2':yo.estanque_tres_2,
              'hora_inicio_2':yo.hora_inicio_2,
              'horas_inicio_ter_ciclo':yo.horas_inicio_ter_ciclo,

              'ciclo_3':yo.ciclo_3,
              'estanque_uno_3':yo.estanque_uno_3,
              'estanque_dos_3':yo.estanque_dos_3,
              'estanque_tres_3':yo.estanque_tres_3,
              'hora_inicio_3':yo.hora_inicio_3,
              'horas_inicio_cuarto_ciclo':yo.horas_inicio_cuarto_ciclo,

              'ciclo_4':yo.ciclo_4,
              'estanque_uno_4':yo.estanque_uno_4,
              'estanque_dos_4':yo.estanque_dos_4,
              'estanque_tres_4':yo.estanque_tres_4,
              'hora_inicio_4':yo.hora_inicio_4,
              'horas_inicio_quinto_ciclo':yo.horas_inicio_quinto_ciclo,

              'ciclo_5':yo.ciclo_5,
              'estanque_uno_5':yo.estanque_uno_5,
              'estanque_dos_5':yo.estanque_dos_5,
              'estanque_tres_5':yo.estanque_tres_5,
              'hora_inicio_5':yo.hora_inicio_5,
              'horas_inicio_sexto_ciclo':yo.horas_inicio_sexto_ciclo,

              'ciclo_6':yo.ciclo_6,
              'estanque_uno_6':yo.estanque_uno_6,
              'estanque_dos_6':yo.estanque_dos_6,
              'estanque_tres_6':yo.estanque_tres_6,
              'hora_inicio_6':yo.hora_inicio_6,
              'horas_inicio_septimo_ciclo':yo.horas_inicio_septimo_ciclo,

              'ciclo_7':yo.ciclo_7,
              'estanque_uno_7':yo.estanque_uno_7,
              'estanque_dos_7':yo.estanque_dos_7,
              'estanque_tres_7':yo.estanque_tres_7,
              'hora_inicio_7':yo.hora_inicio_7,


              'comentarios':yo.comentarios,
              'estado': '0',
              'con_usuario': yo.id_user,

            })

            const config = {
              method: 'put',
              url: 'riego/editar/'+yo.id_editar,
              headers: {
                'Content-Type': 'application/json'
              },
              data: data
            }


            axiosIns(config)
                .then(function (response) {
                  if (response.status === 200){
                    yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se editó de manera correcta", 'success', 5000)
                  }
                })
                .catch(function (error) {
                  console.log(error);
                  yo.mostrarNotificacion('Error en la edición', 'BellIcon', 'Error: \n '+error.toString(), 'danger', 5000)
                })
                .finally(function (){
                  yo.mostrarSemAct=false
                  yo.mostrarSemSgte=false
                //   yo.traerRiegos()

                  yo.$nextTick(() => {
                    yo.$refs['modal-editar'].toggle('#toggle-btn')
                  })
                  yo.loadingEditar = false
                })

          }
        })
      },

      resetModal() {

        // this.dataInicial()

        this.semana = this.semanaActual ? this.semana : this.semana_sig
      },

      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.registrarNuevo()
      },

      validarRegistroEditar(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.editarRegistro()
      },

      importarOk(bvModalEvtImp) {
        // Prevent modal from closing
        bvModalEvtImp.preventDefault()
        // Trigger submit handler
        this.enviarFile()
      },

      mostrarNotificacion(titulo, icono, texto, variante, tiempo){
        this.$toast({
              component: ToastificationContent,
              props:{
                title: titulo,
                icon: icono,
                text: texto,
                variant: variante
              }
            },
            {
              timeout: tiempo,
              position: 'top-center',
            })
      },

      comporbarExcedente(){

        const suma = parseFloat(this.lunes) + parseFloat(this.martes) + parseFloat(this.miercoles) + parseFloat(this.jueves) + parseFloat(this.viernes) + parseFloat(this.sabado) + parseFloat(this.domingo)
        const resultado = (suma / parseInt(this.dias)).toLocaleString('es-PE', {maximumFractionDigits: 5})

        this.mostrarAlert = resultado !== this.total_max_dia;

        let c = 0

        c = parseFloat(this.lunes) !== 0 ? c+1 : c
        c = parseFloat(this.martes) !== 0 ? c+1 : c
        c = parseFloat(this.miercoles) !== 0 ? c+1 : c
        c = parseFloat(this.jueves) !== 0 ? c+1 : c
        c = parseFloat(this.viernes) !== 0 ? c+1 : c
        c = parseFloat(this.sabado) !== 0 ? c+1 : c
        c = parseFloat(this.domingo) !== 0 ? c+1 : c

        this.mostrarAlert2 = c !== parseInt(this.dias);

      },

      numeroDeSemana(fecha){
        const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24, DIAS_QUE_TIENE_UNA_SEMANA = 7, JUEVES = 4;

        // fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()+7));
        fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));

        let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
        if (diaDeLaSemana === 0) {
          diaDeLaSemana = 7;
        }

        fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);

        const inicioDelAnio = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));

        const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAnio;

        return {
          n_semana: Math.ceil(((diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS) + 1) / DIAS_QUE_TIENE_UNA_SEMANA),
          inicio: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() - fecha.getDay() + 1),
          fin: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() + 7 - fecha.getDay()),
        }

      },

      asignarInicioFinSemana(){
        this.inicioSemana = ''
        this.finSemana = ''

        if (this.semana >= 1 && this.semana <= 52){
          const hoy = new Date()
          const fech = new Date(Date.UTC(hoy.getFullYear(), 0, 1));

          fech.setDate(fech.getDate() + (this.semana*7));

          const inicio = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() - fech.getDay() + 1)
          const fin = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() + 7 - fech.getDay())

          this.inicioSemana = inicio.toLocaleString('pe-PE', {
            month: 'long',
            day: '2-digit',
            year: 'numeric',
            localeMatcher: 'best fit',
            timeZone: 'America/Lima'
          })
          this.finSemana = fin.toLocaleString('pe-PE', {
            month: 'long',
            day: '2-digit',
            year: 'numeric',
            localeMatcher: 'best fit',
            timeZone: 'America/Lima'
          })
        }
      },

      enviarFile(){
        const yo = this
        this.$refs.formularioImportar.validate().then(success => {
          if (success) {
            this.loadingIMP = true
            const data = new FormData();
            data.append('file', yo.archivo_excel)
            data.append('con_usuario', yo.id_user)
            data.append('semana', yo.semanaEnviar)
            data.append('parametros_usuario', JSON.stringify(yo.parametros_usuario))

            const config = {
              method: 'post',
              url: '/riego/importar/filter/',
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              data: data
            }

            axiosIns(config)
                .then(function (response) {
                  if(response.status === 200){
                    // yo.traerRiegos()

                    if (response.data['errores']){
                      yo.respuestaErrores=response.data['errores']
                      yo.mostrarErrores=true
                    }else{
                      if(response.data['total']=='-1'){
                        yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "El registro no se realizó porque los anteriores ya pasaron a estado Revisado", 'warning', 6000)
                      }
                      else{
                        yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "La importación se realizó correctamente", 'success', 5000)
                      }

                    }


                  }
                })
                .catch(function (error) {
                  console.log(error);

                  yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Error en el registro',
                      icon: 'XIcon',
                      text: 'Hubo un error en el registro, intentelo nuevamente en unos minutos.',
                      variant: 'danger',
                    },
                  })
                })
                .finally(function () {
                  yo.archivo_excel = null
                  yo.cultivoIMP = null
                  yo.loadingIMP = false
                  yo.$nextTick(() => {
                    yo.$refs['modal-importar'].toggle('#toggle-btn')
                  })

                  // yo.estadoModalRespuesta = true
                })
          }
        })
      },

      verDetalle(datos){
        const yo=this
        yo.selectAll=false
        yo.selected=[]
        yo.estado_btn_descargamasiva=true

        // Obtener el id de la fila seleccionada
        const idSeleccionado = datos.id;
        yo.detalle_sociedad = datos.sociedad
        // Filtrar los elementos de items_detalle que coincidan con el id seleccionado
        this.items_detalle = this.items_completo.filter(items_completo => items_completo.id === idSeleccionado);
        yo.mostrarSemAct = true
      },

      verDetalleSemSgte(datos){
        const yo = this
        yo.items_sem_sgte = yo.spd.filter(invoice => invoice.semana+invoice.cultivo+invoice.empresa+invoice.fundo === datos.semana+datos.cultivo+datos.empresa+datos.fundo)

        yo.mostrarSemSgte = true
      },

      asignarMaxDiaSemana(){
        const yo = this
        yo.lunes = '0.0'
        yo.martes = '0.0'
        yo.miercoles = '0.0'
        yo.jueves = '0.0'
        yo.viernes = '0.0'
        yo.sabado = '0.0'
        yo.domingo = '0.0'

        if (yo.dias >= 1 && yo.dias <= 7){
          for (let i = 1; i<=7; i++){
            if (i<=yo.dias && i===1){
              yo.lunes = yo.total_max_dia
            }

            if (i<=yo.dias && i===2){
              yo.martes = yo.total_max_dia
            }

            if (i<=yo.dias && i===3){
              yo.miercoles = yo.total_max_dia
            }

            if (i<=yo.dias && i===4){
              yo.jueves = yo.total_max_dia
            }

            if (i<=yo.dias && i===5){
              yo.viernes = yo.total_max_dia
            }

            if (i<=yo.dias && i===6){
              yo.sabado = yo.total_max_dia
            }

            if (i<=yo.dias && i===7){
              yo.domingo = yo.total_max_dia
            }

          }
        }
      },

      descargarPlantilla(){
        const yo = this
        const config = {
          method: 'get',
          url: '/fertilizacion/plantilla/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer'
        }

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {

                const fileURL = window.URL.createObjectURL(new Blob([response.data]))
                const fileLink = document.createElement('a')
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Plantilla_PRG_AGR.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();

                yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Archivo creado',
                        icon: 'CheckIcon',
                        text: 'El archivo se creó satisfactoriamente.',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    })
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en la creación del archivo',
                  icon: 'XIcon',
                  text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            });
      },

      mostrarModalEditar(datos){

        const yo = this
        yo.estadoModalEditar = true
        yo.id_editar = datos['id']
        yo.semana = datos['semana']
        yo.empresa = datos['empresa']

        this.asignarCultivos()
        yo.cultivo = datos['cultivo']
        this.asignarFundos()
        yo.fundo = datos['fundo']
        this.asignarEtapas()
        yo.etapa = datos['etapa']
        this.asignarCampos()
        yo.campo = datos['campo']
        this.asignarTurnos()
        yo.turno = datos['turno']
        this.asignarCodigos()

        yo.codigo_h=datos['cod_homologado']

        yo.variedad = datos['variedad']
        yo.lote = datos['lote']
        yo.valvula = datos['valvula']
        yo.area = datos['area']

      },

      filtros(){
        this.items = this.spd
        this.items = this.items.filter(
            invoice =>
                invoice.empresa === (this.empresaFiltro || invoice.empresa) &&
                invoice.semana === (this.semanaFiltro || invoice.semana) &&
                invoice.cultivo === (this.cultivoFiltro || invoice.cultivo)
        )
        this.totalRows = this.items.length
      },

      buscarResponsable(){
        return new Promise(resolve => {
          const yo = this
          yo.loading = true

          const config = {
            method: 'get',
            url: '/consulta_responsable/?id='+ yo.id_user
          }

          let spd = []

          axiosIns(config)
              .then(function (response) {
                if(response.status === 200){
                  yo.responsable = response.data
                  spd = response.data
                }

              })
              .catch(function (error) {
                console.log(error);
                yo.mostrarNotificacion('¡Advertencia!', 'AlertTriangleIcon', "No se encontraron datos con el usuario ingresado.", 'warning', 2000)
              })
              .finally(function (){
                resolve()
              })
        });
      },

      modal_registro(valor){
        const yo = this
        yo.msj_error_cargaarchivos=''
        yo.tipo=''
        yo.descripcion=''
        yo.archivos_htm=[]
        yo.modal_registro_o = true

      },

    //   descargarRegistros(valor){
    //     const yo = this

    //     const semmm = valor ? yo.semana : yo.semana_sig
    //     const datos = yo.items_completo.filter(invoice => invoice.semana === semmm)

    //     yo.loadingSAD = valor
    //     yo.loadingSSD = !valor

    //     const data = JSON.stringify(
    //         {
    //           "datas":datos
    //         }
    //     )

    //     const config = {
    //       method: 'post',
    //       url: '/riego/exportar/filter/',
    //       headers: {
    //         'Content-Type': 'application/json'
    //       },
    //       responseType: 'arraybuffer',
    //       data : data
    //     };

    //     axiosIns(config)
    //         .then(function (response) {
    //           if (response.status === 200) {
    //             const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    //             const fileLink = document.createElement('a');
    //             fileLink.href = fileURL;
    //             fileLink.setAttribute('download', "Exportar detalle Riego - semana "+ semmm +".xlsx");
    //             document.body.appendChild(fileLink);
    //             fileLink.click();

    //             yo.$toast({
    //                   component: ToastificationContent,
    //                   props: {
    //                     title: 'Archivo creado',
    //                     icon: 'CheckIcon',
    //                     text: 'El archivo se creó satisfactoriamente.',
    //                     variant: 'success',
    //                   },
    //                 },
    //                 {
    //                   position: 'top-center',
    //                 })
    //           }
    //         })
    //         .catch(function (error) {
    //           console.log(error);
    //           yo.$toast({
    //             component: ToastificationContent,
    //             props: {
    //               title: 'Error en la creación del archivo',
    //               icon: 'XIcon',
    //               text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
    //               variant: 'danger',
    //             },
    //           })
    //         })
    //         .finally(function () {
    //           yo.loadingSAD = false
    //           yo.loadingSSD = false
    //         });
    //   }

    },
  }
  </script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .custom-file-input:lang(en) ~ .custom-file-label::after {
    content: '';
  }


  .tablaferti{
    min-height: 52vh!important;
  }

  .tablaferti::-webkit-scrollbar {
    width: 1.35vh;
    height: 1.35vh;
  }
  .tablaferti::-webkit-scrollbar-track {
    background-color: rgba(171, 171, 171, 0.35);
    border-radius: 6px;
    position: absolute;
  }
  .tablaferti::-webkit-scrollbar-thumb {
    background-image: linear-gradient(47deg, #82868b, #9ca0a4);
    border-radius: 6px;
    position: absolute;
  }

  </style>
